// tslint:disable-next-line:variable-name
export const FeedBackStateConstant = {
  FilterStateName: 'feedBackFilter',
};

// tslint:disable-next-line:variable-name
export const FeedBackFilterActions = {
  SetFilter: 'SET_FEEDBACK_FILTER',
};
